/* Clipperton (28/10, copie 225, vitesse) : cœur « favoris » sur les vignettes produit, sorti de snippets/cl-fav-header.liquid
   et gardé en cache d’une page à l’autre. Les deux textes (anglais ou français) restent écrits dans la page
   (window.clFavL, même fichier). Même code. */
(function () {
  if (window.clFavCards) return;
  window.clFavCards = true;
  var L = window.clFavL || {};
  var K = 'cl_favorites', L_OFF = L.off || 'Save to favorites', L_ON = L.on || 'Remove from favorites';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6 4.2 12.9a4.7 4.7 0 0 1 0-6.7 4.7 4.7 0 0 1 6.7 0l1.1 1.1 1.1-1.1a4.7 4.7 0 0 1 6.7 0 4.7 4.7 0 0 1 0 6.7L12 20.6Z"/></svg>';
  function read() { try { return JSON.parse(localStorage.getItem(K)) || []; } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(K, JSON.stringify(v)); } catch (e) {} }
  function handleOf(href) { var m = String(href || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function addButtons() {
    document.querySelectorAll('product-block:not(.product-block--compact)').forEach(function (pb) {
      var box = pb.querySelector('.image-cont');
      if (!box || box.querySelector('.cl-favc')) return;
      var a = pb.querySelector('a.product-link[href]');
      var h = a && handleOf(a.getAttribute('href'));
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cl-favc';
      b.setAttribute('data-cl-favc', '');
      b.setAttribute('data-handle', h);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', L_OFF);
      b.innerHTML = HEART;
      box.appendChild(b);
    });
  }
  function infoOf(b) {
    var pb = b.closest('product-block');
    var a = pb.querySelector('a.product-link[href]');
    var url = a.getAttribute('href').replace(/\/collections\/[^\/]+\/products\//, '/products/');
    var t = pb.querySelector('.product-block__title');
    var img = pb.querySelector('.product-block__image--primary img, .image-cont img');
    var src = img ? (img.getAttribute('src') || '') : '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    src = src.replace(/([?&])width=\d+/, '$1width=400');
    var price = '';
    var cur = pb.querySelector('.price__current');
    if (cur) {
      var c = cur.cloneNode(true);
      c.querySelectorAll('.visually-hidden, .price__from').forEach(function (n) { n.remove(); });
      price = c.textContent.replace(/\s+/g, ' ').trim();
    }
    return { handle: b.getAttribute('data-handle'), title: t ? t.textContent.trim() : '', url: url, img: src, price: price };
  }
  function paint() {
    var on = {};
    read().forEach(function (i) { on[i.handle] = true; });
    document.querySelectorAll('[data-cl-favc]').forEach(function (b) {
      var is = !!on[b.getAttribute('data-handle')];
      b.classList.toggle('is-on', is);
      b.setAttribute('aria-pressed', is ? 'true' : 'false');
      b.setAttribute('aria-label', is ? L_ON : L_OFF);
    });
  }
  function refresh() { addButtons(); paint(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cl-favc]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle'), list = read(), idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].handle === h) { idx = i; break; } }
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(infoOf(b)); }
    write(list);
    document.dispatchEvent(new CustomEvent('cl:favorites-changed'));
  }, true);
  document.addEventListener('cl:favorites-changed', paint);
  window.addEventListener('storage', paint);
  var timer = null;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refresh); } else { refresh(); }
})();
